<!-- ATOM: GlobalSnackbar.vue -->
<!-- Application-wide snackbar rendered once in the root layout — driven by useSnackbar(). -->

<script setup lang="ts">
//
// Composables
//
const {
  snackbar,
  snackbarText,
  snackbarColor,
  snackbarTimeout,
  snackbarIcon,
  snackbarActionText,
  snackbarActionHandler,
  hideSnackbar,
} = useSnackbar();

//
// Methods
//

/** Invoke the registered action handler and close the snackbar. */
const handleAction = () => {
  hideSnackbar();
  snackbarActionHandler.value?.();
};
</script>

<template>
  <v-snackbar v-model="snackbar" :timeout="snackbarTimeout" :color="snackbarColor" location="bottom" rounded="lg">
    <div class="d-flex align-center ga-2">
      <v-icon v-if="snackbarIcon" :icon="snackbarIcon" size="small" />
      <span>{{ snackbarText }}</span>
    </div>

    <template v-if="snackbarActionText" #actions>
      <v-btn variant="text" color="white" @click="handleAction">
        {{ snackbarActionText }}
      </v-btn>
    </template>
  </v-snackbar>
</template>
